export const APPOINTMENT_TYPE_OPTIONS = [
  {
    value: "online_booking",
    label: "Online booking",
    description: "Booked through the online booking page/app (self-service).",
  },
  {
    value: "by_receptionist",
    label: "By receptionist",
    description: "Booked by front desk/reception on behalf of the client.",
  },
  {
    value: "by_technician",
    label: "By technician",
    description: "Booked internally by a technician/staff member.",
  },
  {
    value: "by_client_during_service",
    label: "By client during service",
    description: "Booked while the client is in-store during an ongoing visit.",
  },
  {
    value: "by_phone",
    label: "By phone",
    description: "Booked via phone call or voicemail request.",
  },
  {
    value: "walk_in",
    label: "Walk in",
    description:
      "Client arrived without a prior booking and was scheduled on the spot.",
  },
  {
    value: "no_show",
    label: "No-show",
    description: "Client did not attend. Kept for tracking and reporting.",
  },
];

export const APPOINTMENT_TYPES = APPOINTMENT_TYPE_OPTIONS.filter(
  (option) => option.value !== "no_show"
).map((option) => option.label);

export function normalizeAppointmentType(raw) {
  if (!raw) return "online_booking";

  const v = String(raw).trim().toLowerCase();

  if (v === "new request" || v === "request") return "online_booking";
  if (v === "salon") return "by_receptionist";
  if (v === "walk in" || v === "walkin") return "walk_in";
  if (v === "no_show" || v === "no-show" || v === "noshow") return "no_show";

  const ok = new Set(APPOINTMENT_TYPE_OPTIONS.map((o) => o.value));
  if (ok.has(v)) return v;

  const labelMatch = APPOINTMENT_TYPE_OPTIONS.find(
    (o) => o.label.toLowerCase() === v
  );
  if (labelMatch) return labelMatch.value;

  return "online_booking";
}

export function appointmentTypeLabel(value) {
  const opt = APPOINTMENT_TYPE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : value || "";
}

export function appointmentTypeDescription(value) {
  const opt = APPOINTMENT_TYPE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.description : "";
}
